import { SxProps, Theme } from '@mui/material';
import variables from './password-form.module.scss';

// Same look as the submit button of the login form (LoginFormInside).
export const primaryButtonSx: SxProps<Theme> = {
    height: 42,
    backgroundColor: variables.appRedColor,
    color: variables.whiteColor,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: variables.appRedColor,
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
    },
    '&:focus': {
        outline: 'none',
    },
};

export const secondaryButtonSx: SxProps<Theme> = {
    height: 42,
    color: variables.appRedColor,
    borderColor: variables.appRedColor,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
        borderColor: variables.appRedColor,
        backgroundColor: 'transparent',
    },
    '&:focus': {
        outline: 'none',
    },
};

export const pageSx: SxProps<Theme> = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    p: '2rem',
    backgroundColor: variables.pageBackgroundColor,
    pt: 10,
};

export const cardSx: SxProps<Theme> = {
    maxWidth: 500,
    width: '100%',
    backgroundColor: variables.whiteColor,
    borderRadius: 3,
    p: 4,
    boxShadow: variables.cardBoxShadow,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};
